import React, { useEffect, useState, useRef } from "react";
import { Helmet } from 'react-helmet-async';
import { motion, useInView } from "framer-motion";
import Navbar from "../components/Navbar";
import { Container, Row, Col, Accordion } from "react-bootstrap";
import { Link } from "react-router-dom";
import Image2 from "../assets/images/alteration/image-2.jpg";
import Image1 from "../assets/images/alteration/image-1.jpg";
import Footer from "../components/Footer";

function Alteration({ setPageTitle }) {

    useEffect(() => {
        setPageTitle("Alteration - Bait Al Anaqah");
    }, [setPageTitle]);

    return (
        <>
        <Helmet>
        <meta name="keywords" content="Bait Al Anaqah, Bespoke, Uniforms, Alteration, Custom, Dubai" />
        <meta name="title" property="og:title" content={setPageTitle}></meta>
        <meta property="og:type" content="website" />
        <meta name="description" property="og:description" content="Experience the elegance of Bait Al Anaqah, where every creation tells a story and reflects your unique identity while honoring your values." />
        <meta name="image" property="og:image" content={Image1} />
        <link rel="canonical" href="https://baitalanaqah.com/alteration" />
      </Helmet>
            <Navbar />
            <div className="vh-100 alteration-background d-flex align-items-center mb-5">
                <Container>
                    <Row>
                        <Col lg={8} className="mx-auto text-center text-light py-5">
                            <h2 className="display-1 mb-5">
                                Tailored to Perfection
                            </h2>
                            <p className="mb-5 px-lg-0 px-4">
                                Breathe new life into your garments with our bespoke alteration services. From
                                minor adjustments to complete transformations, we ensure every piece fits
                                flawlessly.
                            </p>
                            <Link to="/book-appointment" className="btn btn-light text-decoration-none text-small rounded-0 mb-3">Book Your Appointment</Link>
                        </Col>
                    </Row>
                </Container>
            </div>
            <Container className="py-5">
                <Row>
                    <Col lg={6} className="mx-auto text-center border-bottom py-5">
                        <h2 className="fst-italic mb-5">
                            Why Choose Our Alteration Services?
                        </h2>
                        <p className="px-lg-0 px-4">
                            At Anaqah, we believe every garment deserves a perfect fit. Whether it's a cherished
                            couture piece or your go-to office wear, our skilled artisans ensure every detail
                            reflects your unique elegance.
                        </p>
                    </Col>
                </Row>
            </Container>
            <Container fluid className="g-0 py-5">
                <Row className="g-0">
                    <Col lg={5} className="mx-auto my-auto pt-5 g-5 order-lg-first order-last text-lg-start text-center">
                        <h2 className="fst-italic mb-5">
                            Our Seamless Process
                        </h2>
                        <h5 className="fw-bold">
                            Book Your Appointment
                        </h5>
                        <p className="">
                            Schedule a fitting with our experts using the form below or visit us in-store.
                        </p>
                        <h5 className="fw-bold">
                            Personalized Consultation
                        </h5>
                        <p className="">
                            Discuss your requirements and let us evaluate your garment for the best
                            alterations.
                        </p>
                        <h5 className="fw-bold">
                            Expert Tailoring
                        </h5>
                        <p className="">
                            Our skilled tailors will meticulously adjust your garment for a flawless fit.
                        </p>
                        <h5 className="fw-bold">
                            Pick-Up or Delivery
                        </h5>
                        <p className="">
                            Collect your finished piece or have it delivered to your doorstep.
                        </p>
                    </Col>
                    <Col lg={5}>
                        <img src={Image2} className="img-fluid" />
                    </Col>
                </Row>
            </Container>
            <Container className="py-5 border-bottom">
                <h2 className="text-center fst-italic mb-5">
                    What Our Clients Say
                </h2>
                <Row>
                    <Col lg={4} className="mx-auto text-center mb-lg-0 mb-5">
                        <p>
                            "I trusted Anaqah with my wedding dress alterations, and it was perfect
                            beyond my dreams!"
                        </p>
                        <p>
                            - Sarah A
                        </p>
                    </Col>
                    <Col lg={4} className="mx-auto text-center">
                        <p>
                            "Their attention to detail is unmatched. My suit feels like it was made for me!"
                        </p>
                        <p>
                            - Ahmed H
                        </p>
                    </Col>
                </Row>
            </Container>
            <Container className="py-5">
                <Row>
                    <Col lg={6} className="mx-auto border-bottom py-5">
                        <h2 className="fst-italic mb-5">
                            Frequently Asked Questions
                        </h2>
                        <Accordion>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>What types of garments do you alter?</Accordion.Header>
                                <Accordion.Body>
                                We specialize in all types, including dresses, suits, abayas, and more.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>How long does the process take?</Accordion.Header>
                                <Accordion.Body>
                                Standard alterations take 3–5 business days. Urgent requests are available
                                upon consultation.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>Do you offer home fittings?</Accordion.Header>
                                <Accordion.Body>
                                Yes, we provide home fitting services for an additional fee within the UAE.
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                </Row>
            </Container>
            <Container className="py-5">
                <Row>
                    <Col lg={6} className="mx-auto text-center">
                        <h2 className="fst-italic mb-5">
                        Ready to experience the perfect fit? Let’s get started today!
                        </h2>
                        <Link to="/book-appointment" className="btn btn-dark text-decoration-none text-small rounded-0 mb-5">Book Your Appointment</Link>
                    </Col>
                </Row>
            </Container>
            <Footer />
        </>
    );
}

export default Alteration;
